import type { ProductKind } from '@iheartjane/types';

export const EQUIVALENCY_TYPE = 'equivalency';

export const EQUIVALENCY_UNIT = 'g';

type CartLimitRuleType = 'product' | 'equivalency';

export interface NuProductType {
  _destroy?: boolean;
  id: number;
  product_subtype: string | null;
  product_type: ProductKind;
}

export type RuleProduct = NuProductType & {
  cart_limit_rule_product_type_id: number;
};

export interface CartLimitRule {
  _destroy?: boolean;
  id?: number;
  limit_unit: string;
  limit_value: number;
  product_group_name: string;
  product_types: readonly RuleProduct[];
  rule_type: CartLimitRuleType;
}

export interface CartLimitPolicy {
  cart_limit_rules: readonly CartLimitRule[];
  id: number;
  name: string;
}

export interface CartLimitRuleReport {
  limit_unit: string;
  limit_unit_total: number;
  limit_value: number;
  normalized_limit: number;
  normalized_total: number;
  product_group_name: string;
}
